import React, { Component } from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/logo-footer.png";
import Socialearns from "../../assets/images/sociolearnLogo.png";
import PlayStore from "../../assets/images/playStore.png";
import AppStore from "../../assets/images/appStore.png";
import { connect } from "react-redux";

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="th-footer-bg pt-4 pb-4">
          <div className="container th-container">
            <div className="row">
              <div className="col-md-3 col-12 d-md-flex pb-md-0 pb-3">
                <div>
                  <div className="text-center mb-2">
                    <img src={Logo} alt="" className="th-footer-logo" />
                  </div>
                  <div className="text-center">
                    <img src={Socialearns} alt="" className="th-footer-text" />
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-6 th-footer-mob-col">
                <div>
                  <h3 className="th-footer-link-head mb-3">Company</h3>
                  <Link className="th-footer-link">
                    <p className="mb-2">About</p>
                  </Link>
                  <Link className="th-footer-link">
                    <p className="mb-2">Careers</p>
                  </Link>
                  <Link className="th-footer-link">
                    <p className="mb-2">Advertising</p>
                  </Link>
                  <Link className="th-footer-link">
                    <p className="mb-2">Small Business</p>
                  </Link>
                </div>
              </div>
              <div className="col-md-3 col-6 th-footer-mob-col">
                <div>
                  <h3 className="th-footer-link-head mb-3">Community</h3>
                  <Link className="th-footer-link">
                    <p className="mb-2">Careers </p>
                  </Link>
                  <Link className="th-footer-link">
                    <p className="mb-2">Catalog</p>
                  </Link>
                  <Link className="th-footer-link">
                    <p className="mb-2">Leadership</p>
                  </Link>
                  <Link className="th-footer-link">
                    <p className="mb-2">What We Offer</p>
                  </Link>
                </div>
              </div>
              <div className="col-md-3 col-12 d-md-flex pt-md-0 pt-4">
                <div>
                  <h3 className="th-footer-link-head mb-3 text-center">
                    Download the app
                  </h3>
                  <div className="mb-3 th-footer-download">
                    <img
                      src={PlayStore}
                      alt=""
                      className="mx-1 th-footer-download-icon"
                    />
                    <img
                      src={AppStore}
                      alt=""
                      className="th-footer-download-icon"
                    />
                  </div>
                  <Link className="th-footer-link2">
                    <p className="mb-2">Community Guidelines</p>
                  </Link>
                  <Link className="th-footer-link2">
                    <p className="mb-md-2 mb-0">Privacy & Terms</p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            this.props.auth.isAuthenticated
              ? "th-footer-copyright-bg-auth"
              : "th-footer-copyright-bg"
          }
        >
          <p className="th-footer-copyright-txt text-center mb-0">
            © 2022 socialearns. All rights reserved.
          </p>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, null)(Footer);
